// Body.js
import React from 'react';
import PropsComponent from "../../props-component/PropsComponent.js";
import "../body.css";
function Body() {
  return (
    <div>
   
      <PropsComponent
      inerdiv1="iPhone15 inerdiv1"
        h1="iPhone 15"
        h2="New camera. New design. Newphoria."
        link1="#"
        link2="#"
      />
      
    </div>
  );
}

export default Body;
